import backIcon from "../back_icon.svg";
import checkIcon from "../check_icon.png";
import whiteCheckIcon from "../check-mark.png";
import addIconLight from "../add_icon_light.png";
import addIconP from "../add_icon.png";
import userIcon from "../user.png";
import logo from "../logo.png";
import closeIcon from "../close_icon.png";
import saveIcon from "../save_icon.png";
import editIcon from "../edit_icon.png";
import downloadIcon from "../download-icon.svg"
import nextIcon from "../next_icon.png";
import previousIcon from "../previous_icon.png";
import deleteIcon from "../delete_Icon.png";
import logoutIcon from "../logout_icon_white.png";
import logoutIconP from "../logout_icon.png";
import analyzeIcon from "../analyzeIcon.png";
import uploadIcon from "../upload_icon.png";
import circledCancelIcon from "../circled_cancel.svg";
import containerIcon from "../container.png";
import infoIcon from "../information.png";
import searchIcon from "../search_icon.png";
import printIcon from "../printer_icon.png";
import skipIcon from "../skip.svg";
import archiveIcon from "../archive_icon.png";
import ProfileCover from "../logo.png";
import ProfilePicture from "../accounting.png";
import resetPassword from "../reset-password.png";
import invoicesIcon from "../invoices.png";
import viewIcon from "../view.png";
import supplierIcon from "../supplier_icon.png";
import deleteCircled from "../circled_cancel.svg";
import DoneIcon from "../done-all.svg";
import copyIcon from "../copy-icon.png";
import uploadIconPrimary from "../upload-arrow-primary.png";

import orderExecutionIcon from "../order_execution.png";
import cancelOrderExecutionIcon from "../cancel_order_execution.png";
import bugReportIcon from "../bug_report.svg";

import sendIcon from "../send_icon.png";
import sendEmail from "../sendEmail.png";
import changeBadge from "../changeBadge.png";

export const ICONS = {
  // Header / profile
  user: userIcon,
  logo: logo,
  profileCover: ProfileCover,
  profilePicture: ProfilePicture,
  resetPassword: resetPassword,

  // General actions
  check: checkIcon,
  whiteCheck: whiteCheckIcon,
  close: closeIcon,
  save: saveIcon,
  edit: editIcon,
  delete: deleteIcon,
  logout: logoutIcon,
  logoutP: logoutIconP, // default version
  search: searchIcon,
  print: printIcon,
  download: downloadIcon,
  skip: skipIcon,
  supplier: supplierIcon,
  deleteCircled: deleteCircled,
  // Back / navigation
  backIcon: backIcon, // keep old key
  back: backIcon, // alias (easier to type)
  next: nextIcon,
  previous: previousIcon,

  // Add icons
  add: addIconLight, // light version
  addP: addIconP, // default version

  // Screens / features
  analyze: analyzeIcon,
  upload: uploadIcon,
  container: containerIcon,
  info: infoIcon,
  archive: archiveIcon,
  invoices: invoicesIcon,
  view: viewIcon,
  done: DoneIcon,
  copy: copyIcon,
  // Cancel / remove (circled cancel)
  cancelCircle: circledCancelIcon,
  circledCancel: circledCancelIcon, // alias
  uploadIconPrimary: uploadIconPrimary,
  bugReport: bugReportIcon,

  // Order execution icons
  orderExecution: orderExecutionIcon,
  cancelOrderExecution: cancelOrderExecutionIcon,


  sendWhiteIcon: sendIcon,
  sendEmail: sendEmail,
  changeBadge: changeBadge
};
